// ink-component
import React, { ButtonHTMLAttributes } from 'react';
import getGlobalProps from '../../../helpers/constants/global-props';
import { TagButtonWrapper } from '../styles';

export interface TagButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

const globalProps = getGlobalProps({});

/**
 * @purpose Tag action button that appends an icon and onClick
 * @group Tag
 * @HTMLType HTMLButtonElement
 */
function TagButton(props: TagButtonProps) {
  const { style, className, ...otherProps } = props;

  return <TagButtonWrapper {...globalProps} {...otherProps} />;
}

TagButton.defaultProps = {
  children: undefined,
  onClick: undefined,
};

TagButton.displayName = 'Tag.Button';

export default TagButton;
